import { AdminService, CreateServiceRequest } from '../../../../types/admin.types';

export const CATEGORY_OPTIONS = [
  'Massage',
  'Body Treatment',
  'Facial',
  'Wellness',
  'Other',
] as const;

export const INITIAL_FORM_DATA: CreateServiceRequest = {
  name: '',
  slug: '',
  description: '',
  duration: 60,
  basePrice: 0,
  depositAmount: undefined,
  imageUrl: undefined,
  requiredQualification: '',
  category: '',
  displayOrder: 0,
};

export interface FormErrors {
  name?: string;
  slug?: string;
  description?: string;
  duration?: string;
  basePrice?: string;
  category?: string;
  requiredQualification?: string;
}

export function generateSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function validateServiceForm(formData: CreateServiceRequest): FormErrors {
  const errors: FormErrors = {};

  if (!formData.name.trim()) {
    errors.name = 'Name is required';
  }
  if (!formData.slug.trim()) {
    errors.slug = 'Slug is required';
  } else if (!/^[a-z0-9-]+$/.test(formData.slug)) {
    errors.slug = 'Slug can only contain lowercase letters, numbers, and hyphens';
  }
  if (!formData.description.trim()) {
    errors.description = 'Description is required';
  }
  if (!formData.duration || formData.duration <= 0) {
    errors.duration = 'Duration must be greater than 0';
  }
  if (formData.basePrice === undefined || formData.basePrice < 0) {
    errors.basePrice = 'Base price must be 0 or greater';
  }
  if (!formData.category) {
    errors.category = 'Category is required';
  }
  if (!formData.requiredQualification.trim()) {
    errors.requiredQualification = 'Required qualification is required';
  }

  return errors;
}

export function initializeFormData(service: AdminService): CreateServiceRequest {
  return {
    name: service.name,
    slug: service.slug,
    description: service.description,
    duration: service.duration,
    basePrice: service.basePrice,
    depositAmount: service.depositAmount ?? undefined,
    imageUrl: service.imageUrl ?? undefined,
    requiredQualification: service.requiredQualification,
    category: service.category,
    displayOrder: service.displayOrder,
  };
}
